/**
 * Tracking Debug helpers.
 * Activated when VITE_GOOGLE_TRACKING_DEBUG=true. Attaches a tiny API to
 * window.obcGoogleTrackingDebug for QA in the browser console.
 *
 * Test conversion events are flagged with debug_mode:true so they will NOT
 * fire to live Google Ads unless the page URL contains ?ads_test=1.
 */

import {
  getGoogleTrackingConfig,
  getConsentState,
  trackGooglePageView,
  trackGoogleLeadConversion,
  trackGoogleQuoteConversion,
  trackGoogleEstimateConversion,
  trackGooglePhoneConversion,
  trackGoogleEmailConversion,
} from './googleTracking';

export function installTrackingDebug(): void {
  if (typeof window === 'undefined') return;
  const cfg = getGoogleTrackingConfig();
  if (!cfg.debug) return;

  const debugBase = (extra: Record<string, unknown> = {}) => ({
    event_id: `debug-${Date.now()}`,
    transaction_id: `debug-${Date.now()}`,
    debug_mode: true,
    event_category: 'debug',
    currency: 'USD',
    form_id: 'debug',
    form_name: 'debug',
    ...extra,
  });

  const api = {
    getConfig: () => getGoogleTrackingConfig(),
    getConsent: () => getConsentState(),
    isReady: () => Boolean((window as any).__obcGoogleConfigReady),
    testPageView: () =>
      trackGooglePageView({
        page_path: window.location.pathname,
        page_title: document.title,
      }),
    testLeadConversion: (value = 1) =>
      trackGoogleLeadConversion(debugBase({ value })),
    testQuoteConversion: (value = 1) =>
      trackGoogleQuoteConversion(debugBase({ value })),
    testEstimateConversion: (value = 1) =>
      trackGoogleEstimateConversion(debugBase({ value })),
    testPhoneConversion: () =>
      trackGooglePhoneConversion(debugBase({ page_path: window.location.pathname })),
    testEmailConversion: () =>
      trackGoogleEmailConversion(debugBase({ page_path: window.location.pathname })),
  };

  (window as any).obcGoogleTrackingDebug = api;
  (window as any).__obcGoogleTrackingDebug = api;
  (window as any).obcGoogleDebug = api;
  // eslint-disable-next-line no-console
  console.info('[googleTracking] debug API installed → window.obcGoogleDebug');
}
